<template>
  <Popup
    class="filter-dialog"
    v-model:show="show"
    position="bottom"
    teleport="body"
  >
    <div class="filter-dialog__header">
      <div class="filter-dialog__title">
        {{ title }}
      </div>
      <Icon
        class="filter-dialog__close"
        name="close-f-2"
        @click="show = false"
      />
    </div>
    <div class="filter-dialog__content">
      <slot />
    </div>
    <div class="filter-dialog__footer">
      <Button @click="$emit('reset')">
        Reset
      </Button>
      <Button
        type="primary"
        @click="$emit('submit')"
      >
        Done
      </Button>
    </div>
  </Popup>
</template>

<script setup>
import { Popup } from '@/components/Popup'
import { Button } from '@/components/Button'
import { Icon } from '../Icon'

defineProps({
  title: { type: String, required: true }
})

const show = defineModel('show', { type: Boolean })

defineEmits(['reset', 'submit'])
</script>

<style lang="less">
.filter-dialog {
  padding: 12px 16px;

  &__header, &__content, &__footer {
    background-color: #fff;
  }

  &__header {
    position: relative;
    padding: 0 16px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px 8px 0 0;
  }

  &__title {
    font-size: 12px;
    font-family: mon-600;
    color: #5c5c5c;
  }

  &__close {
    font-size: 24px;
    color: #232323;
  }

  &__content {
    padding: 0 16px 16px;
    overflow: scroll;
  }

  &__footer {
    border-radius: 0 0 8px 8px;
    border-top: .5px solid #e4e6eb;
    padding: 12px 16px 16px;
    display: flex;
    justify-content: center;
    gap: 11px;
  }
}
</style>
